export default "__VITE_ASSET__DG_ye4kS__"